// extracted by mini-css-extract-plugin
module.exports = {"reason_container":"ReasonMessage_reason_container__1EZ41","reason_fieldset":"ReasonMessage_reason_fieldset__jX66q"};